export default {"src":"/_next/static/image/public/images/ic_clock_timer.4fa8402081abb1ac187c09e235d15eeb.svg","height":11,"width":11};